export default __webpack_public_path__ + "static/media/login-thumbnail.147cfb03.jpg";